export default "__VITE_ASSET__CKEtB9Kp__"